import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLegacyRecepcionVehiculoPorId } from '../../helpers/api_helper';

const useRecepcionVehiculoPorId = (idRecepcion, refresh = 0) => {
    const [recepcion, setRecepcion] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);

    useEffect(() => {
        const fetchRecepcion = async () => {
            if (!idRecepcion || !tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getLegacyRecepcionVehiculoPorId({
                    tenantId,
                    empresa,
                    idRecepcion
                });
                console.log('Response from API for recepcion by ID:', response);
                if (response.id_recep) {
                    setRecepcion(response);
                } else {
                    throw new Error('No se encontró la recepción solicitada');
                }
            } catch (err) {
                const errorMessage = `Failed to fetch recepcion: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setRecepcion(null);
            } finally {
                setLoading(false);
            }
        };

        fetchRecepcion();
    }, [idRecepcion, tenantId, empresa, departamento, refresh]);

    return { recepcion, loading, error };
};

export default useRecepcionVehiculoPorId;